import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from "../../../../base.component";
import { CodingField } from "@models/field/coding-field.model";
import { CustomCodingFieldsManager } from "@models/review/custom-coding-fields-manager";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { LexbeCodingTextBox } from "@models/lexbe-coding-text-box.model";
import { DocViewerStore } from "@store/legacy/doc-viewer.store";
import { map } from "rxjs";
import { take } from "rxjs/operators";
import { CustomCodingFieldsValuesManager } from "@utilities/custom-coding-fields-values-manager";
import { LexbeCodingCheckBox } from "@models/lexbe-coding-check-box.model";

@Component({
    selector: 'lex-custom-coding-section',
    templateUrl: './custom-coding-section.component.html',
    styleUrls: ['./custom-coding-section.component.scss'],
    standalone: false
})
export class CustomCodingSectionComponent extends BaseComponent implements OnInit {
	@Input() public customField: CodingField;
	public children: CodingField[];
	public codingSectionForm: FormGroup;

	constructor(
		private customCodingFieldsManager: CustomCodingFieldsManager,
		private customCodingFieldsValuesManager: CustomCodingFieldsValuesManager,
		private fb: FormBuilder,
		private docViewerStore: DocViewerStore
	) {
		super();
	}

	public ngOnInit(): void {
		this.children = this.customCodingFieldsManager.getChildren(this.customField.fieldId);
		this.createForm();
	}

	public createForm() {
		this.docViewerStore.currentDocument$.pipe(
			take(1),
			map((document) => {
				return this.children.map((child) => {
					if (child.type === 1) {
						const existingField = this.customCodingFieldsValuesManager.ccfTextBoxes.get(child.fieldId);
						if (existingField) {
							return existingField;
						}

						const field = new LexbeCodingTextBox();
						const match = document.customCodingFields.find(f => f.fieldId === child.fieldId);

						field.fieldId = child.fieldId;
						field.docId = document.docId;
						field.text = match ? (match as LexbeCodingTextBox).text : '';
						return field;
					} else {
						const existingField = this.customCodingFieldsValuesManager.ccfCheckBoxes.get(child.fieldId);
						if (existingField) {
							return existingField;
						}

						const field = new LexbeCodingCheckBox();
						const match = document.customCodingFields.find(f => f.fieldId === child.fieldId);

						field.fieldId = child.fieldId;
						field.docId = document.docId;
						field.checked = match ? (match as LexbeCodingCheckBox).checked : false;
						return field;
					}
				});
			})
		).subscribe((codingField) => {
			const formControls = {};
			codingField.forEach((rr) => {
				if (rr instanceof LexbeCodingTextBox) {
					const formControl = new FormControl(rr.text);
					formControls[rr.fieldId] = formControl;

					this.customCodingFieldsValuesManager.ccfTextBoxes.set(rr.fieldId, rr);

					formControl.valueChanges.subscribe((change) => {
						// Refactor when removing old DocViewer and remove ccvmanager
						rr.text = change;
						this.customCodingFieldsValuesManager.ccfTextBoxes.set(rr.fieldId, rr);
						this.updateState();
					});
				}

				if (rr instanceof LexbeCodingCheckBox) {
					const formControl = new FormControl(rr.checked);
					formControls[rr.fieldId] = formControl;

					this.customCodingFieldsValuesManager.ccfCheckBoxes.set(rr.fieldId, rr);

					formControl.valueChanges.subscribe((change) => {
						// Refactor when removing old DocViewer and remove ccvmanager
						rr.checked = change;
						this.customCodingFieldsValuesManager.ccfCheckBoxes.set(rr.fieldId, rr);
						this.updateState();
					});
				}
			});
			this.codingSectionForm = this.fb.group(formControls);
		});
	}

	private updateState(){
		this.docViewerStore.updateState((currentState) => {
			currentState.hasUnsavedCustomCodingChanges = true;
			return currentState;
		})
	}
}
